module.exports = __webpack_public_path__ + "static/media/linkdin.adf69e5b.svg";